import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchClientInvoices,
  setLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
  reStateFilters,
  deSelectAllInvoices,
} from "@/reducers/clientinvoice";
import { fetchFiltersData } from "@/reducers/clientscandidates";

import ModalPopUp from "../../ModalPopUp";
import CalendarFilter from "../ListingFilters/CalendarFilter";
import DropDownFilter from "../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../ListingFilters/FilterModalTop";
import InvoiceStatus from "../ListingFilters/InvoiceStatus";
import TextFieldFilter from "../ListingFilters/TextFieldFilter";

/**
 * This is a functional component for the Filter Modal.
 */
const FilterModal = () => {
  const { filters, showFilters, pagination } = useSelector(
    (state) => state.clientInvoices,
  );

  const { filterLists } = useSelector((state) => state.clientsCandidates);

  const dispatch = useDispatch();
  /**
   * Handles the closing of the modal.
   *
   * @param {boolean} fromBtn - indicates if the function is called from a button
   * @return {void}
   */
  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showFilterModal(false));
  };
  /**
   * Function to handle the apply action.
   *
   * @return {void}
   */
  const handleApply = () => {
    dispatch(setLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllInvoices());
    dispatch(fetchClientInvoices(filters));
    handleClose();
  };
  /**
   * Function to handle reset.
   */
  const handleReset = () => {
    dispatch(updateFilters({}));
    dispatch(setLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllInvoices());
    dispatch(
      fetchClientInvoices({
        search: filters.search,
      }),
    );
    handleClose();
  };
  useEffect(() => {
    dispatch(fetchFiltersData());
  }, []);
  return (
    <ModalPopUp
      show={showFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[12px]">
          <div className="grid gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <InvoiceStatus
              active={filters.invoiceStatus}
              handleClick={(value) => {
                dispatch(updateFilters({ invoiceStatus: value }));
              }}
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allCandidates?.length > 0
                  ? filterLists?.allCandidates
                  : []
              } // this is the list of candidates
              id="candidateId"
              label="Candidate"
              placeholder="Select Candidate"
              value={filters.candidateId} // selected candidate
              handleChange={(value) => {
                dispatch(updateFilters({ candidateId: value }));
              }} // function to handle change of candidate
              isMultiple={true}
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ invoiceReferenceNo: value }));
              }}
              label="Invoice Reference No."
              value={filters.invoiceReferenceNo}
              filterId="invoiceReferenceNo"
              placeholder="Enter Invoice Reference No."
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ contractReferenceNo: value }));
              }}
              label="Contract Reference No."
              value={filters.contractReferenceNo}
              filterId="contractReferenceNo"
              placeholder="Enter Contract Reference No."
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allRoles?.length > 0
                  ? filterLists?.allRoles
                  : []
              } // this is the list of roles
              id="candidateRole"
              label="Role"
              placeholder="Select Role"
              value={filters.candidateRole} // selected role
              handleChange={(value) => {
                dispatch(updateFilters({ candidateRole: value }));
              }} // function to handle change of role
            />
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Invoice Date (From - To)"
              dateFrom={filters.invoiceDateFrom}
              dateTo={filters.invoiceDateTo}
              handleChange={(value) => {
                dispatch(
                  updateFilters({
                    invoiceDateFrom: value.dateFrom,
                    invoiceDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};

export default FilterModal;
